// Firebase Analytics (native only) via @capacitor-firebase/analytics.
//
// Web builds get GA4 (gtag.js) instead — see the `analytics` object in
// src/lib/analytics.ts, which forwards every event here too when running
// natively. The plugin is loaded lazily + defensively so a web build (or
// a device where the plugin failed to register) never throws.

import { isNativePlatform } from "@/lib/platform";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let FirebaseAnalytics: any = null;

async function getFirebase() {
  if (!isNativePlatform()) return null;
  if (FirebaseAnalytics) return FirebaseAnalytics;
  try {
    const mod = await import("@capacitor-firebase/analytics");
    FirebaseAnalytics = mod.FirebaseAnalytics;
    return FirebaseAnalytics;
  } catch {
    return null;
  }
}

export const mobileAnalytics = {
  setUser: async (userId: string, role: string) => {
    const fb = await getFirebase();
    if (!fb) return;
    try {
      await fb.setUserId({ userId });
      await fb.setUserProperty({ key: "role", value: role });
    } catch {
      /* never throw into the call site */
    }
  },

  screenView: async (screenName: string) => {
    const fb = await getFirebase();
    if (!fb) return;
    try {
      await fb.logEvent({
        name: "screen_view",
        params: { screen_name: screenName, screen_class: screenName },
      });
    } catch {
      /* ignore */
    }
  },

  event: async (eventName: string, params?: Record<string, string | number>) => {
    const fb = await getFirebase();
    if (!fb) return;
    try {
      await fb.logEvent({ name: eventName, params });
    } catch {
      /* ignore */
    }
  },
};
